<template>
  <div>
    <el-form
      ref="formRef"
      :model="searchForm"
      style="width:100%"
      :inline="true"
      :label-position="'right'"
      size="mini"
      :rules="formRules"
    >
      <el-form-item label="昵称/手机号">
        <el-input v-model="searchForm.keyword" clearable></el-input>
      </el-form-item>
      <el-form-item label="优惠券名称">
        <el-input v-model="searchForm.couponName" clearable></el-input>
      </el-form-item>
      <el-form-item label="领取时间">
        <el-date-picker
          v-model="searchForm.receivedBeginTime"
          type="date"
          placeholder="选择日期"
          style="width:150px"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
        ~
        <el-date-picker
          v-model="searchForm.receivedEndTime"
          type="date"
          placeholder="选择日期"
          style="width:150px"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="使用时间">
        <el-date-picker
          v-model="searchForm.usedBeginTime"
          type="date"
          placeholder="选择日期"
          style="width:150px"
        >
        </el-date-picker>
        ~
        <el-date-picker
          v-model="searchForm.usedEndTime"
          type="date"
          placeholder="选择日期"
          style="width:150px"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="过期时间">
        <el-date-picker
          v-model="searchForm.couponBeginTime"
          type="date"
          placeholder="选择日期"
          style="width:150px"
        >
        </el-date-picker>
        ~
        <el-date-picker
          v-model="searchForm.couponEndTime"
          type="date"
          placeholder="选择日期"
          style="width:150px"
        >
        </el-date-picker>
      </el-form-item>

      <el-form-item label="使用状态">
        <el-select
          v-model="searchForm.useStatus"
          clearable
          placeholder="请选择"
          style="width:150px"
        >
          <el-option
            v-for="item in useStatusOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="success" @click="loadPage(1)">查询</el-button>
      </el-form-item>
    </el-form>

    <el-table
      :data="tableData"
      style="width: 100%"
      border
      size="mini"
      v-loading="loading"
    >
      <el-table-column
        type="index"
        label="序号"
        width="50"
        align="center"
      ></el-table-column>
      <el-table-column label="会员信息" align="center">
        <template slot-scope="scope">
          <span
            >{{ scope.row.subscriberName }} /
            {{ scope.row.subscriberPhone }}</span
          >
        </template>
      </el-table-column>
      <el-table-column
        prop="storeCouponName"
        label="优惠券名称"
        align="center"
      ></el-table-column>
      <el-table-column prop="storeCouponType" label="优惠券类型" align="center">
        <template slot-scope="scope">
          {{ scope.row.storeCouponType | couponTypeFilter(couponTypeOptions) }}
        </template>
      </el-table-column>
      <el-table-column prop="useStatus" label="使用状态" align="center">
        <template slot-scope="scope">
          {{ scope.row.useStatus | couponStatusFilter(useStatusOptions) }}
        </template>
      </el-table-column>
      <el-table-column
        prop="created"
        label="领取时间"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="useTime"
        label="使用时间"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="endTime"
        label="过期时间"
        align="center"
      ></el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="searchForm.pageNum"
      :page-sizes="[10, 20, 50]"
      :page-size="searchForm.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="searchForm.total"
    >
    </el-pagination>
  </div>
</template>
<script>
import { selectParameterInfoBusiness } from "@/api/api";
import { storeSubscriberCouponPage } from "@/api/store";
export default {
  filters: {
    couponTypeFilter(type, couponTypeOptions) {
      if (couponTypeOptions && couponTypeOptions.length > 0) {
        return couponTypeOptions.find(item => item.paraValue == type).paraName;
      }
      return type;
    },
    couponStatusFilter(type, couponStatusOptions) {
      if (couponStatusOptions && couponStatusOptions.length > 0) {
        return couponStatusOptions.find(item => item.value == type).label;
      }
      return type;
    }
  },
  data() {
    return {
      searchForm: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },

      couponTypeOptions: [],
      useStatusOptions: [
        {
          label: "未使用",
          value: 0
        },
        {
          label: "已使用",
          value: 1
        },
        {
          label: "已过期",
          value: 2
        }
      ],
      formRules: {},
      tableData: [],
      loading: false
    };
  },
  mounted() {
    this.getBizCouponTypeOptions();
    this.loadPage();
  },
  methods: {
    loadPage(num) {
      this.$refs.formRef.validate(valid => {
        console.log(valid);
        if (valid) {
          if (num) {
            this.searchForm.pageNum = num;
          }
          this._loadPage();
        }
      });
    },
    _loadPage() {
      this.loading = true;
      storeSubscriberCouponPage(this.searchForm)
        .then(resp => {
          if (resp.data.status == 100) {
            this.tableData = resp.data.results.list;
            this.searchForm.total = resp.data.results.total;
          } else {
            this.$message({
              message: resp.data.message,
              type: "error"
            });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getBizCouponTypeOptions() {
      let _self = this;
      selectParameterInfoBusiness({
        startRows: 1,
        pageSize: 100,
        paraType: "biz_coupon_type"
      }).then(resp => {
        if (resp.data.results) {
          _self.couponTypeOptions = resp.data.results.list.map(e => {
            e.paraValue = Number(e.paraValue);
            return e;
          });
        }
      });
    },
    handleSizeChange(pageSize) {
      this.searchForm.pageSize = pageSize;
      this.loadPage();
    },
    handleCurrentChange(page) {
      this.searchForm.pageNum = page;
      this.loadPage();
    }
  }
};
</script>
<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// couponList.vue?7db10bf9